import getStandaloneLoader from './package-loader';
import { humanEvent, startDetectHumanEvent } from '../commonUtil/humanDetect';

// We need this event handling to occur as early as possible and keep the results in
// an object so that passing the object by value allows the property to change
// as a side-effect until needed.

startDetectHumanEvent();

const loadEngagementViewer =
    getStandaloneLoader('seismic-engagement-viewer-ui', '__seismic_engagement_viewer_ui_version__', true);

loadEngagementViewer.load().then((payload) => {
    payload.ui.DisplayViewer(payload.imageCDNUrl, humanEvent);
});
